<template>
    <vs-popup classContent="popup-example"  title="ویرایش اطلاعات کاتالوگ" :active.sync="showPopup">
        <form class="px-4" @keydown.enter="editCatalogInfo()">
            <div class="vx-row px-5 mb-4">
                <div class="vx-col w-2/5">
                    <label class="vs-input--label">عنوان</label>
                    <vs-input class="w-full mt-2" v-model="title" />
                </div>
                <div class="vx-col w-1/2">
                    <label class="vs-input--label">آدرس فایل</label>
                    <vs-input class="w-full mt-2" v-model="url" />
                </div>
                <div class="vx-col w-1/2 upload-btn-wrapper mt-4">
                    <label class="vs-input--label">آپلود عکس</label>
                    <b-form-file
                        v-model="file"
                        placeholder="Choose a file or drop it here..."
                        drop-placeholder="Drop file here..."
                        accept="image/*"
                        class="mt-2"
                    />
                    <!-- <input type="file" id="file" ref="file"  @change="uploadImg()" /> -->
                </div>
                <div class="vx-col w-1/5 mt-4">
                    <img :src="srcFile" style="width: 100%;height:auto;">
                </div>
                <!-- <div class="vx-col w-full">
                    <label class="vs-input--label">توضیحات</label>
                    <vs-textarea v-model="text" class="mt-4" />
                </div> -->
            </div>

            <vs-row class="mt-4" vs-w="12" vs-type="flex" vs-justify="center">
                <vs-col class="sm:w-1/2 w-full">
                    
                </vs-col>
                <vs-col class="sm:w-1/2 w-full">
                    <vs-button class="mr-3 float-right" @click="editCatalogInfo()">ثبت</vs-button>
                </vs-col>
            </vs-row>
        </form>
    </vs-popup>
</template>

<script>
import { BFormFile } from 'bootstrap-vue'

export default {
    name: 'EditCatalog',

    props: {
        popupEditCatalog: {
            type: Boolean,
            default: false,
        },
        catalogId: Number
    },
    
    components: {
        BFormFile
    },
    
    data() {
		return{
            showPopup: false,
            file: [],
            title: '',
            thumbnail: '',
            text: ' ',
            url: '',
            srcFile: '',
		}
    },
    
    computed: {
    },

    watch: {
      	popupEditCatalog: function(newVal) {
            this.showPopup = newVal
            if(newVal == true){
                this.$vs.loading()
                this.$store.dispatch('getPostInfo', this.catalogId)
                .then(res => {
                    localStorage.setItem('postId', this.catalogId)
                    this.title = res.data[0].title
                    this.thumbnail = res.data[0].thumbnail
                    this.text = res.data[0].text
                    this.url =res.data[0].url
                    this.srcFile = 'https://appapi.akambc.com/' + this.thumbnail
                    this.$vs.loading.close()
                }).catch(() => {
                    this.$vs.loading.close()
                    this.$vs.notify({
                        title: '',
                        text: 'خطا در اتصال به اینترنت',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'warning'
                    })
                })
            }
        },

        showPopup: function(newVal) {
            this.$emit('updatePopupEditCatalog', newVal)
            this.title = ''
            this.thumbnail = ''
            this.text = ''
            this.url = ''
        },
    },

    created(){	
    },
    
    methods: {
        uploadImg() {
            this.file = this.$refs.file.files[0];
        },

        editCatalogInfo(){
			this.$vs.loading()
            this.$emit('updatePopupEditCatalog', false)
            let formData = new FormData();
            formData.append('thumbnail', this.file);
            formData.append('title', this.title);
            formData.append('text', this.text);
            formData.append('id', this.id);
            formData.append('type', 'catalog');
            formData.append('url', this.url);
            formData.append('order', 0);
                        
            this.$store.dispatch('updatePostInfo', formData)
			.then(() => {
                this.$vs.loading.close()
                this.$vs.notify({
					title: '',
					text: 'کاتالوگ با موفقیت ویرایش شد.',
					iconPack: 'feather',
					icon: 'icon-check-square',
					color: 'success'
				})
            })
            .catch(() => {
                this.$vs.loading.close()
                this.$vs.notify({
                    title: '',
                    text: 'اطلاعات ارسالی صحیح نمی باشد.',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'warning'
				})
			})
		},
    }
}
</script>